/**
 * DefaultRedirect Component
 * Redirects users to appropriate default page based on role
 * - Delivery users -> /jobs
 * - Other users -> /dashboard
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks/redux';
import { getDefaultLandingPath } from '../../navigation/pageAccess';

export const DefaultRedirect: React.FC = () => {
  const { user } = useAppSelector((state) => state.auth);

  const target = getDefaultLandingPath(user);
  return <Navigate to={target} replace />;
};

DefaultRedirect.displayName = 'DefaultRedirect';
